import { render } from "./modal-manifest.vue?vue&type=template&id=45123219&scoped=true&ts=true"
import script from "./modal-manifest.vue?vue&type=script&lang=ts"
export * from "./modal-manifest.vue?vue&type=script&lang=ts"

import "./modal-manifest.vue?vue&type=style&index=0&id=45123219&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45123219"]])

export default __exports__